"use client"

import { useEffect } from "react";
import { Crisp } from "crisp-sdk-web";

const CrispChat = () => {
  useEffect(() => {
    Crisp.configure("d8f9e4b2-de11-47c7-97bd-5b19b448844b");
  });

  return null;
}

export default CrispChat;